import {Component} from '@angular/core';
import {NavParams, LoadingController} from "ionic-angular";
import {HomePage} from "../home/home";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    templateUrl: 'service.html',
    selector: 'recharge-website-page'
})
export class RechargeWebsitePage {
    title: string = "Nạp tiền";
    trustedUrl: any;
    loading: any;

    constructor(private navParams: NavParams, private sanitizer: DomSanitizer, public loadingCtrl: LoadingController) {
        let url = navParams.get("url") + "&lname=" + HomePage.loginname;
        this.loading = loadingCtrl.create({
            content: ''
        });
        this.loading.present();
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    webLoad(event) {
        this.loading.dismiss().catch(() => {
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/service/rechargeWebsite.ts